// src/pages/EmpleadoDashboard.jsx
import React, { useState, useEffect } from 'react';
import api from '../../api/api';
import ClientLayout from '../../components/ClientLayout';

const COLORS = {
    SIERRA_GREEN: '#2E5B2E',
    CANTERA_PINK: '#C19A6B',
    WHITE: '#FFFFFF',
    GRAY: '#F3F4F6'
};

function EmpleadoDashboard() {
    const [sucursales, setSucursales] = useState([]);
    const [pedidos, setPedidos] = useState([]);
    const [selectedSucursal, setSelectedSucursal] = useState('');
    const [stockForm, setStockForm] = useState({ grano: '', molido: '' });
    const [loading, setLoading] = useState(true);

    // Recuperamos los datos del jefe desde el objeto guardado en login
    const user = JSON.parse(localStorage.getItem('user'));
    const ownerId = user?.parentId; 

    useEffect(() => {
        const fetchData = async () => {
            const token = localStorage.getItem('token');
            const config = { headers: { Authorization: `Bearer ${token}` } };
            try {
                // Consultamos usando el ID del superior
                const [sucRes, pedRes] = await Promise.all([
                    api.get(`/sucursales/usuario/${ownerId}`, config),
                    api.get(`/pedidos/usuario/${ownerId}?limit=8`, config)
                ]);
                
                setSucursales(sucRes.data || []);
                setPedidos(pedRes.data.data || []);
                if (sucRes.data?.length > 0) setSelectedSucursal(sucRes.data[0].id);
            } catch (err) {
                console.error("Error al heredar datos del parentId", err);
            } finally {
                setLoading(false);
            }
        };
        if (ownerId) fetchData();
    }, [ownerId]);

    const handleUpdateStock = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('token');
            await api.patch(`/inventario/${selectedSucursal}`, {
                cantidadGrano: Number(stockForm.grano),
                cantidadMolido: Number(stockForm.molido)
            }, { headers: { Authorization: `Bearer ${token}` } });
            alert("✅ Inventario de sucursal actualizado con éxito");
        } catch (err) {
            alert("Error al actualizar stock");
        }
    };

    if (loading) return <div style={{padding: 50, textAlign: 'center'}}>Cargando panel operativo...</div>;

    return (
        <ClientLayout title="Panel Operativo de Empleado">
            <div style={styles.grid}>
                
                {/* REGISTRO DE STOCK */}
                <div style={styles.card}>
                    <h3 style={styles.cardHeader}>⚖️ Registro de Existencias</h3>
                    <form onSubmit={handleUpdateStock}>
                        <label style={styles.label}>Sucursal a reportar:</label>
                        <select 
                            style={styles.select} 
                            value={selectedSucursal} 
                            onChange={e => setSelectedSucursal(e.target.value)}
                        >
                            {sucursales.map(s => <option key={s.id} value={s.id}>{s.nombre}</option>)}
                        </select>
                        
                        <div style={styles.inputRow}>
                            <div style={{flex: 1}}>
                                <label style={styles.miniLabel}>Kilos Grano</label>
                                <input type="number" step="0.1" style={styles.input} onChange={e => setStockForm({...stockForm, grano: e.target.value})} placeholder="0.0" />
                            </div>
                            <div style={{flex: 1}}>
                                <label style={styles.miniLabel}>Kilos Molido</label>
                                <input type="number" step="0.1" style={styles.input} onChange={e => setStockForm({...stockForm, molido: e.target.value})} placeholder="0.0" />
                            </div>
                        </div>
                        <button type="submit" style={styles.btnAction}>Actualizar Inventario</button>
                    </form>
                </div>

                {/* LISTA DE PEDIDOS RECIENTES */}
                <div style={styles.card}>
                    <h3 style={styles.cardHeader}>🚚 Pedidos Recientes (Negocio)</h3>
                    <div style={styles.scrollArea}>
                        {pedidos.map(p => (
                            <div key={p.id} style={styles.orderItem}>
                                <div>
                                    <div style={styles.orderSuc}>{p.sucursal?.nombre || 'General'}</div>
                                    <div style={styles.orderDate}>{new Date(p.createdAt).toLocaleDateString()}</div>
                                </div>
                                <span style={{...styles.statusBadge, background: p.estado === 'ENTREGADO' ? '#D1FAE5' : '#FEF3C7'}}>
                                    {p.estado}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </ClientLayout>
    );
}

const styles = {
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '25px' },
    card: { background: COLORS.WHITE, padding: '30px', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' },
    cardHeader: { marginTop: 0, color: COLORS.SIERRA_GREEN, marginBottom: '20px', fontSize: '1.2rem' },
    label: { display: 'block', marginBottom: '8px', fontWeight: 'bold', fontSize: '0.9rem' },
    select: { width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #DDD', marginBottom: '15px' },
    inputRow: { display: 'flex', gap: '15px', marginBottom: '20px' },
    miniLabel: { fontSize: '0.75rem', color: '#666', display: 'block', marginBottom: '4px' },
    input: { width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #DDD' },
    btnAction: { width: '100%', padding: '14px', background: COLORS.SIERRA_GREEN, color: '#FFF', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' },
    scrollArea: { maxHeight: '300px', overflowY: 'auto' },
    orderItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid #F3F4F6' },
    orderSuc: { fontWeight: 'bold', fontSize: '0.9rem' },
    orderDate: { fontSize: '0.8rem', color: '#999' },
    statusBadge: { padding: '4px 10px', borderRadius: '20px', fontSize: '0.7rem', fontWeight: 'bold' }
};

export default EmpleadoDashboard;